//对axios进行二次封装,将刚才下载好的axios导入进来
import axios from "axios";
const CancelToken = axios.CancelToken;

const source = CancelToken.source();


//2. 利用axios对象的方法create,去创建一个axios实例
//requests就是axios,只不过稍微配置一下

// export const hyrequest = axios.create({
//     //基础路径
//     baseURL: 'http://10.33.64.123:8073', // 所有请求的公共地址部分
//     timeout: 3000 // 请求超时时间,这里的意思是当请求时间超过5秒还未取得结果时,提示用户请求超时
// })
// export const apigetJson = axios.create({
//     //基础路径
//     baseURL: '', // 所有请求的公共地址部分
//     timeout: 3000 // 请求超时时间,这里的意思是当请求时间超过5秒还未取得结果时,提示用户请求超时
// })

export const api = axios.create({
    //基础路径
    baseURL: '/api', // 所有请求的公共地址部分s
    timeout: 300000 // 请求超时时间,这里的意思是当请求时间超过5秒还未取得结果时,提示用户请求超时
})

api.interceptors.request.use(config => {

    return config
}, err => {

    Promise.reject(err)
})


api.interceptors.response.use(res => {

    // console.log(res)
    return res.data
}, err => {

    Promise.reject(err)
})

export default api;





